import * as React from "react";
import { Alert as AlertBasic, AlertProps } from "@fluentui/react-northstar";

const Alert: React.FunctionComponent<AlertProps> = (props: AlertProps) => {
  return <AlertBasic {...props} />;
};
export default Alert;
